import { QueryClientProvider } from "@tanstack/react-query";
import { queryClient } from "api/queryClient";
import { ThemeContextProvider } from "modules/Providers/ThemeContext";
import { router } from "modules/Routes/router";
import { RouterProvider } from "react-router";
import { AuthStateProvider } from "./features/authContext";

function App() {
	return (
		<QueryClientProvider client={queryClient}>
			<AuthStateProvider>
				<ThemeContextProvider>
					<RouterProvider router={router} />
				</ThemeContextProvider>
			</AuthStateProvider>
		</QueryClientProvider>
	);
}

export default App;
